"use client";

import React from "react";
import Link from "next/link";

const IntroSection: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Seeing real Invisalign before and after results is one of the most
          powerful ways to feel confident about moving forward with your smile
          transformation, and at{" "}
          <Link
            href="/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            Smile4Me Dental Care
          </Link>
          , we make it easy to explore what&apos;s possible for your unique
          situation. Whether you&apos;re dealing with{" "}
          <Link
            href="/blog/can-invisalign-fix-crowded-teeth/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            overcrowding
          </Link>
          , gaps, or a bite that&apos;s never felt quite right, we&apos;re here
          to show you exactly what treatment can look like from start to
          finish.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed font-semibold">
          <Link
            href="https://app.nexhealth.com/appt/smile4me_dental_care?lid=77847&tracking_key=b2d71902-5ce0-43c1-bc95-24cdee27de9a"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            Schedule a consultation
          </Link>{" "}
          by booking online or calling us at{" "}
          <a
            href="tel:+17184004400"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            (718) 400-4400
          </a>{" "}
          today!
        </p>
      </div>
    </section>
  );
};

export default IntroSection;
